import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AllPhenomena from '../components/AllPhenomena'
import { } from '../actions/radarSettings'

export default connect(
    state => {
        const {
            radarSettings: {
                id,
                canEditRadar,
                votingOn,
                ratingsOn,
                commentsOn,
                group
            },
            filters: {
                activeFilter,
                activeTagFilter,
                showAssessmentStatus
            },
            assessmentData: {
                perPhenomenon: assessmentData
            }
        } = state

        return {
            radarId: id,
            canEdit: canEditRadar,
            filter: activeFilter,
            tagFilter: activeTagFilter,
            votingOn,
            ratingsOn,
            commentsOn,
            showAssessmentStatus,
            assessmentData,
            radarGroupId: group?.id,
            publicPhenomenaGroups: state.dataContext?.publicPhenomenaGroups ?? []
        }
    },
    dispatch => bindActionCreators({
    }, dispatch)
)(AllPhenomena)
